module.exports = __webpack_public_path__ + "static/media/intro-3.cd8bb13b.jpg";